import React from "react";
import styled from "styled-components";
import IUMRSNavBar from "./IUMRSNavbar";
import { ICAMNavroute } from "../../../utils/ICAMnavroute";
import IUMRSFooter from "./IUMRSFooter"
import { useDesktopSiteDetection } from "../../../hooks/mobile_desktop_mode";
import NotificationDropdown from "../../../hooks/notificationsDropdown";

const IUMRSAccommodation = () => {

  const isDesktopSiteOnMobile = useDesktopSiteDetection()

    const hotels = [
        {
          name: "Tomerik Hotel",
          location: "Lagos Avenue Road in East Legon",
          description: (
                        <>
                          Tomreik Hotel is a Three (3) Star Hotel situated Ten (10) minutes away from the Kotoka International Airport.
                          Use code <b>ICAM 2025</b> to enjoy lower rates when booking any of our rooms.
                        </>
          ),
          website: "https://tomreikhotel.com/",
          image: "https://tomreikhotel.com/wp-content/uploads/2024/04/IMG_6092-1024x768.jpg"
        },
        {
          name: "MJ Grand Hotel",
          location: "Abochieman street, off Lagos Avenue, East Legon.",
          description: "MJ GRAND HOTEL is an Accommodation Establishment located in a cosy environment, five(5) minutes drive from the Kotoka International Airport...",
          website: "https://www.mjgrandhotelghana.com/",
          image: "https://www.mjgrandhotelghana.com/images/gallery/thumb/gallery-3.jpg"
        },
        {
          name: "Fiesta Royal",
          location: "George W. Bush Hwy, Accra",
          description: "The Fiesta Royale offers 100 spacious rooms, including ten 2- bedroom chalets surrounded by the immaculately manicured gardens...",
          website: "https://fiestahospitality.com/",
          image: "https://fiestahospitality.com/wp-content/uploads/Fiesta-Royale-00007518-800-3x2-1-400x284.jpg.webp"
        },
        {
          name: "African Reagent Hotel",
          location: "237/238 N Airport Rd, Accra",
          description: "The hotel provides every traveler into the city, be it for business or leisure, the opportunity to explore and experience Accra...",
          website: "https://www.theafricanregenthotel.com/",
          image: "https://r.profitroom.com/theafricanregenthotel/images/gallery/thumbs/1920x1080/ea3332ac-0fe5-4b88-a7bf-afec0919ed91.jpg?updated=2025-03-20_05-39"
        },
        {
            name: "Mensvic Grand Hotel",
            location: "Lagos Ave, Accra",
            description: "Mensvic Grand Hotels has one of the largest and finest conference and banquet hotel in East Legon, Airport City and it environs...",
            website: "https://mensvichotels.com/",
            image: "https://mensvichotels.com/wp-content/uploads/2019/11/double-bg.jpg"
        },
        {
            name: "Lancaster Accra Hotel",
            location: "Liberation Road, Accra",
            description: "Lancaster Accra is a 4-Star Superior First Class hotel with a lovely ambiance and delightfully landscaped in style over spacious grounds with lush vegetation...",
            website: "https://lancasteraccra.com/",
            image: "https://lancasteraccra.com/assets/img/Rooms/JuniorSuite.jpg"
        },
        {
          name: "GS Plaza",
          location: "Plot 26, South Legon, Accra, Ghana",
          description: "We have meeting facilities for the business traveller; 2 restaurants for the gourmet food lover; and a swimming pool, gym, badminton court...",
          website: "https://www.gsplazahotel.com/",
          image: "https://s3-cdn.hotellinksolutions.com/hls/data/1491/gallery/thumbs/full_executive-suite_1_1446462463.jpg"
        },
        {
          name: "Ange Hill Hotel",
          location: "Ange Hill Street East Legon, Accra, Ghana",
          description: "Situated in Accra, 11 km from Kwame Nkrumah Memorial Park, Ange Hill Hotel features accommodation with an outdoor swimming pool, free private parking...",
          website: "https://angehillhotel.com-accra.com/",
          image: "https://static21.com-hotel.com/uploads/hotel/97811/photo/lg_ange-hill-hotel_17239119044.jpg"
        },
        {
          name: "Oscarpak Royal Hotel",
          location: "No 10, Off Legon Haatso Road, P. O. Box GP 343, Accra",
          description: "A garden, laundry facilities, and a bar are just a few of the amenities provided at Oscarpak Royal Hotel. Stay connected with free in-room WiFi...",
          website: "https://www.hotels.com/ho396614/oscarpak-royal-hotel-accra-ghana/",
          image: "https://images.trvl-media.com/lodging/5000000/4740000/4738800/4738766/709cc4f9.jpg?impolicy=resizecrop&rw=1200&ra=fit"
        },
        {
            name: "Erata Hotel",
            location: "Ouagadougou Ave, Accra",
            description: "In the heart of Accra, Erata Hotel offers all guests the height of Ghanaian hospitality. A 3-star establishment, we provide comfortable rooms...",
            website: "https://eratahotel.com/",
            image: "https://images.trvl-media.com/lodging/16000000/15840000/15832000/15831922/4485d64a.jpg?impolicy=resizecrop&rw=575&rh=575&ra=fill"
        },
        {
          name: "Yiri Lodge",
          location: "University Of Ghana, Legon, Accra",
          description: "Yiri Lodge offers a warm welcome with English breakfast, a cozy bar, and an on-site restaurant...",
          website: "https://yiri-lodge-accra.accra-hotels-gh.com/en/",
          image: "https://yiri-lodge-accra.accra-hotels-gh.com/data/Photos/OriginalPhoto/6507/650740/650740752/accra-yiri-lodge-0-photo-6.JPEG"
        },
      ];

    return(
        <Container>
            <IUMRSNavBar navroute={ICAMNavroute}/>
            <NotificationDropdown />
            <Content>
                <div className="header">
                    <h2>ACCOMMODATION DETAILS</h2>
                </div>

                <Body className={isDesktopSiteOnMobile ? 'desktop-site-mode' : ''}>
                    <div className="intro-text">
                        <span><i>Attendees note</i></span>  
                    </div>

                    <div className="main-text">
                        <p>Please note that while successful registration does not include accommodation, we have curated a 
                          list of hotels that are both affordable and conveniently located near the Cedi Conference Center, 
                          where the event will take place. These hotels are situated between 10 to 25 minutes from Kotoka 
                          International Airport, ensuring easy access to both the airport and the conference venue.</p>
                        <p>Attendees who require assistance in securing accommodations can contact our team to make lodging 
                          arrangements for them in any of our recommended hotels or other lodging facilities.</p><br />

                        <p><span className="heading">Local Transportation</span>: Once in Ghana, the conference venue is easily 
                        accessible by public transportation, taxis, or even on foot, depending on your accommodation. For 
                        attendees staying at nearby hotels, we may offer transportation services to the conference center. 
                        Additionally, many of the hotels provide excellent service staff who can assist with directions and 
                        transportation arrangements, both from the airport and to the venue. We recommend planning your route 
                        in advance and allowing ample time for travel to ensure timely arrival at the conference.
                        </p>

                        <p>The listed hotels can be booked from the hotel's associated website or through third party sites like 
                          <a href="https://www.booking.com/country/gh.html" target="_blank" rel="noopener noreferrer"> Booking.com</a>.</p>
           
                    </div>

                    <HeaderContainer>
                      <HeaderDivider>
                          <div className="line"></div>
                              <div className="diamond">
                              <Title>List of Nearby Recommended Hotels</Title>
                              </div>
                          <div className="line"></div>
                      </HeaderDivider>
                  </HeaderContainer>
                    <AccommodationContainer>
                        {hotels.map((hotel, index) => (
                            <HotelCard key={index}>
                                <HotelImage src={hotel.image} alt={hotel.name} />
                                <HotelInfo>
                                    <HotelName>{hotel.name}</HotelName>
                                    <HotelLocation>Location: {hotel.location}</HotelLocation>
                                    <HotelDescription>{hotel.description}</HotelDescription>
                                    <HotelButton href={hotel.website} target="_blank" rel="noopener noreferrer">
                                    Visit Website
                                    </HotelButton>
                                </HotelInfo>
                            </HotelCard>
                        ))}
                        </AccommodationContainer>
                </Body>
            </Content>

            <IUMRSFooter />
        </Container>
    )
}

const Container = styled.div`


`

const Content = styled.div`
    font-family: "Noto Serif", serif;
    font-weight: 300;

  .header {
    width: 100%;
    height: 10rem;
    background-color: #082D4A;
    margin: 0;
    text-align: center;
    
    h2 {
      margin: 0;
      color: white;
      font-family: "PT Serif", serif;
      font-style: normal;
      font-weight: 600;
      letter-spacing: .005em;
      font-size: 1.5rem;
      line-height: 10rem;
    }
  }

   @media only screen and (min-width: 800px) {
        .header{
            h2{font-size: 2rem;}
        }
    }

`

const Body = styled.div`
    margin: 2em 2em 1em 2em;

    p{
        color:  rgb(97, 96, 96);
        line-height: 1.8em;
        font-size: 1.1em;
    }

    .main-text {text-align: justify}

    .intro-text {
        width: 100%;
        display: flex;
        justify-content: center;
        text-align: center;
        margin-bottom: 1.5rem;

        span{
            color:  #082D4A;
            font-weight: 600;
            font-size: 1.7rem;
        }
        
        
        p {
            max-width: 90%;
            
            
        }
    }

    .heading {
        color: #082D4A;
        font-weight: 500;
    }

    @media only screen and (min-width: 800px) {
        margin: 3em 3em 1em 3em;

        .intro-text {margin-top: 3rem;}
    }

    @media only screen and (min-width: 1000px) {
        width: 56em;
        margin: 0 auto;
    }

    &.desktop-site-mode {
        
        .main-text{
            margin: 0.5em;
            
            p {
                font-size: 0.65em;
                line-height: 1.5em;
            }
        }
        
        .intro-text span {
            font-size: 2em;
        }
        
        .heading {
            font-size: 0.9em;
        }
    }
`

const AccommodationContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  padding: 20px;
  width: 90%;
  max-width: 1200px;
  margin: 2rem auto;
`;

const HeaderContainer = styled.div`
  text-align: center;
  margin-bottom: 3rem;
  margin-top: 8rem;
`;

const HeaderDivider = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1rem;

  .line {
    height: 2px;
    background-color: #d1d5db;
    width: 7rem;
  }

  .diamond {
    margin: 0 1rem;
  }
`;

const Title = styled.h2`
  font-size: 1.5rem;
  font-weight: bold;
  text-transform: uppercase;
  color: #1f2937;

  @media (max-width: 768px) {
    font-size: 1.2em;
  }
`;

const HotelCard = styled.div`
  display: flex;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  width: 100%;
  max-width: 900px;
  margin: 0 auto;
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);
  }

  @media (max-width: 768px) {
    flex-direction: column;
    max-width: 350px;
  }
`;

const HotelImage = styled.img`
  width: 250px;
  height: 250px;
  object-fit: cover;
  flex-shrink: 0;

  @media (max-width: 768px) {
    width: 100%;
    height: 250px;
  }
`;

const HotelInfo = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex-grow: 1;
  gap: 10px;

  @media (max-width: 768px) {
    padding: 15px;
  }
`;

const HotelName = styled.h3`
  margin: 0;
  font-size: 1.5em;
  color: #082D4A;
  font-weight: 600;
`;

const HotelLocation = styled.div`
  font-size: 1em;
  color: #555;
  margin-bottom: 10px;
`;

const HotelDescription = styled.div`
  font-size: 0.95em;
  color: #666;
  line-height: 1.6;
  margin-bottom: 15px;
`;

const HotelButton = styled.a`
  display: inline-block;
  background: #082D4A;
  color: white;
  padding: 10px 15px;
  text-decoration: none;
  border-radius: 6px;
  font-weight: 600;
  text-align: center;
  transition: background 0.3s ease;
  align-self: flex-start;

  &:hover {
    background: rgb(3, 34, 57);
  }

  @media (max-width: 768px) {
    width: 87%;
  }
`;

export default IUMRSAccommodation;